module.exports = __webpack_public_path__ + "img/FI.2ec09f16.svg";